import { type PropsWithChildren } from "react";
import { cn } from "@/lib/utils";

export interface EditorFieldWrapperProperties extends PropsWithChildren {
  toHide?: boolean;
  isEdited?: boolean;
}

export const EditorFieldWrapper = ({
  toHide = false,
  isEdited = false,
  children,
}: EditorFieldWrapperProperties) => {
  if (children == null) {
    return null;
  }
  return (
    <div
      className={cn(
        toHide && "hidden",
        isEdited && "-ml-2 rounded-r border-l-4 border-primary pl-2",
      )}
    >
      {children}
    </div>
  );
};
